import Vue from 'vue';
import { AxiosPromise } from 'axios';
import {
  Response,
  TireStoringInfo,
} from '@/models';

class TireStoringInfoService extends Vue {
  private ROOT_API = process.env.VUE_APP_ROOT_API + '/webapi/tire-info';

  public get(id: string): AxiosPromise<Response<TireStoringInfo>> {
    return Vue.axios.get<Response<TireStoringInfo>>(this.ROOT_API + '/' + id);
  }

  public getWithStatus(id: string, status: number, status02 = 0): AxiosPromise<Response<TireStoringInfo>> {
    return Vue.axios.get<Response<TireStoringInfo>>(this.ROOT_API + '/get-with-status/' + id + '/' + status + '/' + status02);
  }

  public getByIds(ids: string[]): AxiosPromise<Response<TireStoringInfo[]>> {
    return Vue.axios.post<Response<TireStoringInfo[]>>(this.ROOT_API + '/multiple', ids);
  }

  public getSelectedContractByIds(ids: string[], ): AxiosPromise<Response<string[]>> {
    return Vue.axios.post<Response<string[]>>(this.ROOT_API + '/selected-contract', ids);
  }

  public getSelectedContractByOneTireIds(ids: string[], ): AxiosPromise<Response<string[]>> {
    return Vue.axios.post<Response<string[]>>(this.ROOT_API + '/selected-contract-by-tires', ids);
  }

}
export const tireStoringInfoService = new TireStoringInfoService();
